import { PaymentDeliveryMethodType } from '@routable/shared';
import {} from './fundingRoutes.types';
export const getFundingRoutesGroupedByCurrency = (fundingRoutes) => fundingRoutes?.reduce((acc, { currencyCodeReceiver, deliveryMethod }) => ({
    ...acc,
    [currencyCodeReceiver]: [...(acc[currencyCodeReceiver] || []), deliveryMethod],
}), {});
const paymentDeliveryMethodsToFundingAccountTypeMap = {
    [PaymentDeliveryMethodType.ANY]: 'bank',
    [PaymentDeliveryMethodType.ACH]: 'bank',
    [PaymentDeliveryMethodType.CHECK]: 'address',
    [PaymentDeliveryMethodType.INTERNATIONAL]: 'international',
    [PaymentDeliveryMethodType.PAYPAL]: 'paypalDirect',
};
const fundingAccountMatchesDeliveryMethod = (fundingAccount, deliveryMethods) => {
    return deliveryMethods.some((method) => {
        const accountTypeKey = paymentDeliveryMethodsToFundingAccountTypeMap[method];
        return accountTypeKey ? !!fundingAccount[accountTypeKey] : false;
    });
};
export const filterCompatibleFundingAccounts = ({ fundingRoutesByCurrency, fundingAccounts, }) => fundingAccounts.filter((account) => {
    const deliveryMethods = fundingRoutesByCurrency[account.currencyCode];
    return deliveryMethods ? fundingAccountMatchesDeliveryMethod(account, deliveryMethods) : false;
});
